/**
 * Lead Import Service - Frontend service for CSV import
 */

import api from "../../../shared/api.jsx";
import { logError } from "../../../shared/utils/logger.js";

/**
 * Download CSV template
 * @returns {Promise<Blob>} CSV template blob
 */
export const downloadTemplate = async () => {
  try {
    const response = await api.binary("/leads/import/template", {}, "text/csv");
    const blob = await response.blob();
    return blob;
  } catch (error) {
    logError("Failed to download template:", error);
    throw error;
  }
};

/**
 * Import leads from CSV file
 * @param {File} file - CSV file to upload
 * @param {boolean} dryRun - Whether to perform a dry run
 * @returns {Promise<Object>} Import result
 */
export const importLeadsFromFile = async (file, dryRun = false) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const url = `/leads/import${dryRun ? "?dryRun=true" : ""}`;
    const response = await api.post(url, formData);

    return {
      success: true,
      data: response.data || response,
    };
  } catch (error) {
    logError("Failed to import leads:", error);
    return {
      success: false,
      error: error.message || "Failed to import leads",
    };
  }
};
